<div [id]="id + '-input-container'" class="search-input-container" [class.disabled]="disabled">
  <rx-icon [id]="id + '-icon'" class="icon" [name]="icon" *ngIf="showIcons && isIconStart"></rx-icon>
  <input
    class="input-field"
    type="text"
    [id]="id + '-input'"
    [placeholder]="placeholder"
    [(ngModel)]="value"
    [disabled]="disabled"
    [name]="id + '-input'"
    autocomplete="off"
    autocorrect="off"
    autocapitalize="none"
    spellcheck="false"
    ngDefaultControl
  />
  <rx-icon [id]="id + '-icon'" class="icon" [name]="icon" *ngIf="!value && showIcons && !isIconStart"></rx-icon>
  <rx-icon
    [id]="id + '-icon-reset'"
    [name]="altIcon"
    *ngIf="value && !busy && showIcons"
    class="red"
    (click)="onReset($event)"
  ></rx-icon>
  <rx-icon [id]="id + '-icon-reset'" [name]="busyIcon" *ngIf="busy && showIcons" (click)="onReset($event)"></rx-icon>
</div>
